export default "__VITE_ASSET__BJg$_M4Y__"